import React, { Component } from 'react'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Grid as OriginalGrid, Row, Col as OriginalCol } from 'react-flexbox-grid'
import { Button, TextInput, Pagination, Colors } from 'advenio-components'
import { Form } from 'formsy-react-2'
import DocumentsTable from './components/DocumentsTable'
import DocumentFilters from '../../../Components/Documents/DocumentFilters'
import DocumentGrid from '../../../Components/Documents/DocumentGrid'
import DistributeWizard from '../DistributeWizard'
import DocumentsActions from '../../../Data/Redux/DocumentsRedux'

var Grid = styled(OriginalGrid)`
  margin: 31px auto;
`

var CRow = styled(Row)`
  margin: 20px 0;
`

var PaginationContainer = styled.div`
  margin: 32px 0px 0px 8px;
`

var HeaderContainer = styled.div`
  width: 90%;
  display: inline-flex;
  font-size: 30px;
  font-weight: bold;
  margin-right: 362px;

  span {
    margin-right: 17px;
    margin-left: 8px;
  }
`

var ViewToggle = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
  margin-left: 12px;
`

var ViewButton = styled.button`
  padding: 6px 12px;
  border: 1px solid ${function (props) { return props.active ? Colors.blue500 : Colors.gray200 }};
  background: ${function (props) { return props.active ? Colors.blue500 : '#FFFFFF' }};
  color: ${function (props) { return props.active ? '#FFFFFF' : '#637381' }};
  border-radius: 4px;
  font-size: 13px;
  cursor: pointer;
  font-weight: 500;
  &:hover {
    opacity: 0.8;
  }
`

var FiltersRow = styled.div`
  display: flex;
  align-items: flex-end;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 16px;
`

var SearchInline = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 8px;
  margin-left: auto;
  margin-bottom: 2px;
`

var SearchButton = styled.div`
  padding-bottom: 30px;
`

class DocumentLibrary extends Component {
  constructor (props) {
    super(props)
    this.state = {
      search: '',
      page: 1,
      perPage: 20,
      filters: {}
    }
  }

  componentDidMount () {
    this.fetchDocuments()
  }

  fetchDocuments = () => {
    var search = this.state.search
    var page = this.state.page
    var perPage = this.state.perPage
    var filters = this.state.filters

    var query = { page: page, per_page: perPage }
    if (search) query.search = search
    if (filters.type) query.type = filters.type
    if (filters.dateFrom) query.date_from = filters.dateFrom
    if (filters.dateTo) query.date_to = filters.dateTo
    this.props.getDocuments(query)
  }

  onFilter = (formData) => {
    this.setState({ search: formData.name || '', page: 1 }, this.fetchDocuments)
  }

  onClickPage = (page) => {
    this.setState({ page: page }, this.fetchDocuments)
  }

  handleFilterChange = (filters) => {
    this.setState({ filters: filters, page: 1 })
    this.props.setFilters(filters)
  }

  handleViewModeChange = (mode) => {
    this.props.setViewMode(mode)
  }

  handleDocumentClick = (id) => {
    this.props.goToDocument(id)
  }

  handleDistribute = (documentId) => {
    this.props.openWizard(documentId, null)
  }

  render () {
    var documents = this.props.documents
    var meta = this.props.meta
    var fetching = this.props.fetching
    var viewMode = this.props.viewMode
    var search = this.state.search
    var page = this.state.page

    return (
      <Grid fluid>
        <Row>
          <OriginalCol xs={12}>
            <CRow end='xs'>
              <HeaderContainer>
                <span>
                  Biblioteca de Documentos
                </span>
                <ViewToggle>
                  <ViewButton
                    active={viewMode === 'table'}
                    onClick={this.handleViewModeChange.bind(this, 'table')}
                  >
                    Tabla
                  </ViewButton>
                  <ViewButton
                    active={viewMode === 'grid'}
                    onClick={this.handleViewModeChange.bind(this, 'grid')}
                  >
                    Tarjetas
                  </ViewButton>
                </ViewToggle>
              </HeaderContainer>
            </CRow>
            <FiltersRow>
              <DocumentFilters onFilterChange={this.handleFilterChange} />
              <Form onSubmit={this.onFilter}>
                <SearchInline>
                  <TextInput
                    name='name'
                    label='Buscar documento'
                    value={search}
                  />
                  <SearchButton>
                    <Button loading={fetching} primary small type='submit'>Buscar</Button>
                  </SearchButton>
                </SearchInline>
              </Form>
            </FiltersRow>
            <PaginationContainer>
              <Pagination
                totalElements={meta ? meta.total : 0}
                elementsPerPage={meta ? meta.per_page : 20}
                onPageClick={this.onClickPage}
                pageSelected={page}
              />
            </PaginationContainer>
            {viewMode === 'table' && (
              <DocumentsTable
                documents={documents}
                fetching={fetching}
                onDistribute={this.handleDistribute}
              />
            )}
            {viewMode === 'grid' && (
              <DocumentGrid
                documents={documents}
                fetching={fetching}
                onDocumentClick={this.handleDocumentClick}
                onDistribute={this.handleDistribute}
              />
            )}
          </OriginalCol>
        </Row>
        <DistributeWizard />
      </Grid>
    )
  }
}

DocumentLibrary.propTypes = {
  documents: PropTypes.array,
  meta: PropTypes.object,
  fetching: PropTypes.bool,
  viewMode: PropTypes.string,
  getDocuments: PropTypes.func.isRequired,
  setViewMode: PropTypes.func.isRequired,
  setFilters: PropTypes.func.isRequired,
  openWizard: PropTypes.func.isRequired,
  goToDocument: PropTypes.func.isRequired
}

var mapStateToProps = function (state) {
  return {
    documents: state.documents.library.documents,
    meta: state.documents.library.meta,
    fetching: state.documents.library.fetching,
    viewMode: state.documents.library.viewMode
  }
}

var mapDispatchToProps = function (dispatch) {
  return {
    getDocuments: function (query) {
      return dispatch(DocumentsActions.fetchDocumentsRequest(query))
    },
    setViewMode: function (mode) {
      return dispatch(DocumentsActions.setViewMode(mode))
    },
    setFilters: function (filters) {
      return dispatch(DocumentsActions.setFilters(filters))
    },
    openWizard: function (documentId, studentId) {
      return dispatch(DocumentsActions.openWizard(documentId, studentId))
    },
    goToDocument: function (id) {
      return dispatch(push('/documents/' + id))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(DocumentLibrary)



// WEBPACK FOOTER //
// ./src/Containers/Documents/DocumentLibrary/index.jsx